<template>
    <v-dialog
        v-model="showDialog"
        persistent
        max-width="500px"
    >
        <v-card height="250px">
            <v-container class="my-2">
                <v-card-title class="text-md-h6 text-center text-break mb-3 font-weight-bold">
                    {{ $t('indicators.messages.go_next_step_question') }}
                </v-card-title>

                <v-card-subtitle class="text-center">
                    {{ $t('indicators.messages.not_reversed_warning_message') }}
                </v-card-subtitle>

                <v-card-actions class="justify-center">
                    <v-btn
                        class="v-btn--primary"
                        text
                        @click="confirmAnswer"
                    >{{ $t('app.confirm') }}</v-btn>

                    <v-btn
                        class="v-btn--secondary"
                        text
                        @click="closeDialog"
                    >{{ $t('app.cancel') }}</v-btn>                    
                </v-card-actions>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "ConfirmNextStepDialog",

    props: {
        showDialog: {
            type: Boolean,
            default: false,
            required: true
        },        
    },

    data() {
        return {
            confirmNextStepDialog: false,
        }
    },

    methods: {

        /**
         * Emits dialog confirmed event
         */
        confirmAnswer() {
            this.$emit('confirmDialog')
        },

        /**
         * Closes the dialog
         */
        closeDialog() {
            this.$emit('cancelConfirmDialog')
        },
    },
}
</script>

<style scoped>

</style>